import { trpc } from 'pos-client/utils/trpc.ts';
import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

export const useOrderJobFulfilmentTechnicians = (
  jobData: ScheduleBoardJobModel | null,
  isEnabled: boolean
) => {
  const {
    data: orderJobFulfilmentTechnicians,
    isFetching: orderJobFulfilmentTechniciansIsLoading,
  } = trpc.getOrderJobFulfilmentTechnicians.useQuery(
    {
      orderId: jobData?.orderId ?? '',
      jobId: jobData?.jobId ?? '',
    },
    {
      enabled:
        jobData?.orderId !== undefined &&
        jobData?.jobId !== undefined &&
        isEnabled === true,
      select: (data) => {
        return data ?? [];
      },
    }
  );

  return {
    orderJobFulfilmentTechnicians,
    orderJobFulfilmentTechniciansIsLoading,
  };
};
